module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/main-visual-6b716202b1e8d4563b8553d767f8777c.jpg";